import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Label as AriaLabel } from "react-aria-components";
import { useDefaultLabelStyle } from "../context.js";
import { base } from "./Label.css.js";
import { Tooltip, TooltipIcon } from "./Tooltip.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseLabel = (t0, ref) => {
  const $ = _c(14);
  let children;
  let props;
  let tooltip;
  if ($[0] !== t0) {
    ({
      tooltip,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = tooltip;
  } else {
    children = $[1];
    props = $[2];
    tooltip = $[3];
  }
  const defaultLabelStyle = useDefaultLabelStyle();
  let t1;
  if ($[4] !== defaultLabelStyle) {
    t1 = base({
      defaultLabelStyle
    });
    $[4] = defaultLabelStyle;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== tooltip) {
    t2 = tooltip != null && tooltip.length > 0 && /*#__PURE__*/_jsx(Tooltip, {
      text: tooltip,
      children: /*#__PURE__*/_jsx(TooltipIcon, {})
    });
    $[6] = tooltip;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== ref || $[11] !== t1 || $[12] !== t2) {
    t3 = /*#__PURE__*/_jsxs(AriaLabel, {
      ref: ref,
      ...props,
      className: t1,
      children: [children, t2]
    });
    $[8] = children;
    $[9] = props;
    $[10] = ref;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export const Label = /*#__PURE__*/React.forwardRef(BaseLabel);
//# sourceMappingURL=Label.js.map